import { CONTACT } from '@/mocks/contactInfo';

export default function FloatingWhatsApp() {
  return (
    <a
      href={CONTACT.whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactez-nous sur WhatsApp"
      className="fixed bottom-6 right-6 z-50 hidden lg:flex w-14 h-14 md:w-16 md:h-16 items-center justify-center rounded-full bg-whatsapp-500 text-white shadow-lg hover:bg-whatsapp-600 transition-all duration-300 hover:scale-110 cursor-pointer"
    >
      <i className="ri-whatsapp-line text-2xl md:text-3xl w-7 h-7 md:w-8 md:h-8 flex items-center justify-center"></i>
    </a>
  );
}